<ng-container [formGroup]="form">
	<mat-form-field>
		<input autocomplete="company-name" matInput formControlName="companyName" placeholder="Company Name" required
			maxlength="50" />
		<mat-error>Required</mat-error>
	</mat-form-field>
	<mat-form-field>
		<input autocomplete="code" matInput formControlName="code" placeholder="Code" required maxlength="10" />
		<mat-error>Required</mat-error>
	</mat-form-field>
	<rpshared-select-list required formControlName="class" placeholder="Class" [items]="class"
		[displayFunc]="displayClass"></rpshared-select-list>
	<mat-form-field>
		<input autocomplete="division-label" matInput formControlName="divisionLabel" placeholder="Division Label" />
	</mat-form-field>
	<mat-form-field>
		<input autocomplete="contract-number" matInput formControlName="contractNumber" placeholder="Contract Number" />
	</mat-form-field>
	<mat-form-field>
		<input autocomplete="task-number" matInput formControlName="taskNumber" placeholder="Task Number" />
	</mat-form-field>
	<mat-form-field>
		<input autocomplete="employer-id-number" matInput formControlName="employerIdentificationNumber"
			placeholder="Employer ID Number" maxlength="10" />
	</mat-form-field>
	<mat-form-field>
		<input autocomplete="billing-email" matInput formControlName="billingEmail" placeholder="Billing Email"
			type="email" required maxlength="256" />
		<mat-error *ngIf="form.get('billingEmail').hasError('email')">
			Invalid email address.
		</mat-error>
		<mat-error *ngIf="form.get('billingEmail').hasError('required')">
			Required
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input autocomplete="daily-vehicle-fee" formControlName="dailyVehicleFee"
			placeholder="Daily Vehicle Fee" [required]="areVehicleFeesRequired">
		</rpshared-currency-input>
		<mat-error *ngIf="form.get('dailyVehicleFee').hasError('invalidNumber')">
			Invalid amount.
		</mat-error>
		<mat-error *ngIf="form.get('dailyVehicleFee').hasError('required')">
			Required
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input autocomplete="weekly-vehicle-fee" formControlName="weeklyVehicleFee"
			placeholder="Weekly Vehicle Fee" [required]="areVehicleFeesRequired">
		</rpshared-currency-input>
		<mat-error *ngIf="form.get('weeklyVehicleFee').hasError('invalidNumber')">
			Invalid amount.
		</mat-error>
		<mat-error *ngIf="form.get('weeklyVehicleFee').hasError('required')">
			Required
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input autocomplete="monthly-vehicle-fee" formControlName="monthlyVehicleFee"
			placeholder="Monthly Vehicle Fee" [required]="areVehicleFeesRequired">
		</rpshared-currency-input>
		<mat-error *ngIf="form.get('monthlyVehicleFee').hasError('invalidNumber')">
			Invalid amount.
		</mat-error>
		<mat-error *ngIf="form.get('monthlyVehicleFee').hasError('required')">
			Required
		</mat-error>
	</mat-form-field>
	<rpshared-select-list required formControlName="regularTimeBasis" placeholder="Regular Time Basis"
		[items]="regularTimeBasisTypes"></rpshared-select-list>
	<rpshared-select-list required formControlName="overtimeBasis" placeholder="Overtime Basis"
		[items]="overtimeBasisTypes"></rpshared-select-list>
	<mat-slide-toggle formControlName="includeWcrReportInInvoice" labelPosition="before" class="custom-slider">WCR
		Report in Invoice
	</mat-slide-toggle>
	<mat-slide-toggle formControlName="isIntegratedWithFlairDocs" labelPosition="before"
		class="custom-slider">Integrated With FlairDocs
	</mat-slide-toggle>
	<mat-slide-toggle formControlName="showWorkOrderNumberOnInvoice" class="custom-slider"
		style="font-size: 0.8125rem; padding-left: 0.6rem !important; padding-right: 0.6rem !important;"
		labelPosition="before">Work Order
		Number On Invoice
	</mat-slide-toggle>
	<mat-slide-toggle formControlName="requireReportingForDuty" labelPosition="before" class="custom-slider">Require Reporting For Duty
	</mat-slide-toggle>
	<rpfsa-railroad-logo gdColumn="-1 / -2" gdRow="1 / 5" fxFlexAlign="center" fxLayoutAlign="center"
		*ngIf="isExistingRailroad"></rpfsa-railroad-logo>
</ng-container>